import { GrantsInterfaceV1 } from './GrantsInterfaceV1';
import { GrantsInterfaceType } from '@clientos/types';

export { createNoopGrantsInterface } from './NoopInterface';

let grantsInterfaceV1: GrantsInterfaceV1;

export function getGrantsInterfaceV1(): GrantsInterfaceType {
  return grantsInterfaceV1.getInterface();
}

export async function initializeGrantsInterfaceV1(): Promise<GrantsInterfaceType> {
  if (grantsInterfaceV1) return grantsInterfaceV1.getInterface();
  grantsInterfaceV1 = new GrantsInterfaceV1();

  return grantsInterfaceV1.getInterface();
}

// Keep backward compatibility
export default initializeGrantsInterfaceV1;
